var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.602 34C21.4293 34 22.9243 32.7077 22.9243 31.1282H16.2798C16.2798 31.8899 16.6298 32.6203 17.2529 33.1589C17.8759 33.6974 18.7209 34 19.602 34ZM29.5688 25.3846V18.2051C29.5688 13.7969 26.8445 10.1067 22.0937 9.13026V8.15385C22.0937 6.96205 20.9808 6 19.602 6C18.2233 6 17.1104 6.96205 17.1104 8.15385V9.13026C12.343 10.1067 9.63533 13.7826 9.63533 18.2051V25.3846L7.49248 27.2369C6.44598 28.1415 7.17687 29.6923 8.65527 29.6923H30.5322C32.0106 29.6923 32.7581 28.1415 31.7116 27.2369L29.5688 25.3846Z",
    fill: "#B2B2B2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 12,
    r: 5.5,
    fill: "#FF5151",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastDefault);
export default __webpack_public_path__ + "static/media/toast_default.a6dc7fc629789dc2465557c2dc66b95e.svg";
export { ForwardRef as ReactComponent };